import { CLICK_HERE_TO_ENTER_DESCRIPTION } from 'mk/autogenerated/translations/imagetitle.dcd847e52ef0843cd09070678db9acf7'
import { jQuery as $ } from 'mk/jQuery';
import mystache from '../../old/mystache';

var ImageTitleEditor = function(parentNode, imageSelector, containerSelectorFun) {
    $(parentNode)
        .on('click', '.image-title-editable', function(e) {
            e.preventDefault();
            var submitUrl = this.getAttribute('data-submit-url');
            var title = $(this).hasClass('blank') ? '' : $(this).text().trim();

            var imageTitle = this;

            var $containerNode = $(containerSelectorFun(this));
            // showForm($(containerSel),submitUrl,title,this);

            var t = mystache.get('.image-title-form-template');
            var d = {
                submitUrl: submitUrl,
                text: title,
            };

            // first remove all already-shown forms
            $('form.image-title-form').remove();

            // render the form
            var html = t(d);
            $containerNode
                .html(html)
                .find('input[name=text]').focus().select();
            $containerNode
                .find('form.image-title-form').on('submit', function(event) {
                    var form = this;
                    event.preventDefault();
                    $.ajax({
                        type: 'post',
                        url: form.action,
                        data: $(form).serialize(),
                    }).done(function(res) {
                        $(imageTitle)
                            .text(res.text || CLICK_HERE_TO_ENTER_DESCRIPTION)
                            .toggleClass('blank', res.text.length === 0);
                        $(form).remove();
                        updateOpacity(false, imageTitle);
                        $(imageTitle).trigger('titlechange', {title: res.text});
                    });
                }).end()
                .find('button.image-title-cancel').on('click', function() {
                    $(this).closest('form.image-title-form').remove();
                    updateOpacity(false, this);
                });

            updateOpacity(true, this);
        });

    var updateOpacity = function(isFormVisible, currentNode) {
        if (imageSelector) {
            $(parentNode)
                .find(imageSelector).toggleClass('image-title-grayed-out', isFormVisible);

            if (isFormVisible) {
                $(currentNode).closest(imageSelector).removeClass('image-title-grayed-out');
            }
        }
    };
};

export {
    ImageTitleEditor as init,
};

export function changeTitle(text, submitUrl, formContainer, callback) {
    var $containerNode = $(formContainer);

    var t = mystache.get('.image-title-form-template');
    var d = {
        submitUrl: submitUrl,
        text: text,
    };

    // first remove all already-shown forms
    $('form.image-title-form').remove();

    // render the form
    var html = t(d);
    $containerNode
        .html(html)
        .find('input[name=text]').focus().select();

    $containerNode
        .find('form.image-title-form').on('submit', function(e) {
            var form = this;
            e.preventDefault();
            $.ajax({
                type: 'post',
                url: form.action,
                data: $(form).serialize(),
            }).done(function(res) {
                $(form).remove();
                callback(res.text);
            });
        }).end()
        .find('button.image-title-cancel').on('click', function() {
            $(this).closest('form.image-title-form').remove();
            callback(text);
        });
}
